// test1326
(1326 && 0);
